"use strict";

/* global dataLayer, __productListingSettings, __searchFilters */

import Mustache from "mustache";
import Loop54Connector from "./loop54-connector";
import Loop54FiltersHandler from "./loop54-filters-handler"; // Currently only works with products
import Templates from "./loop54-templates";
import Loop54Promos from "./loop54-promos";
const loop54promos = new Loop54Promos();

let Settings = {
	showSuggestionsAfter: 150,
	updateFiltersAfter: 500,
	minSuggestionLetters: 2,
	endpoint: false, // relative url
	searchMakesNoSenseText: "Valitettavasti emme ymmärtäneet hakuasi",
	stateStoreKey: "ListingStatesStore",
	searchParamKey: "searchParam",
	searchScopeTermKey: "searchScopeTerm",
	searchScopeKey: "searchScope",
	pageParam: "sivu",
	idParam: "id",
	facetsParam: "userFacets",
	orderParam: "orderBy",
	searchQueryParam: "q",
	scopedQueryParam: "scoped",
	scopeParam: "scope",
	titleSuffix: "| Budgetsport",
	loop54Mode: "search", // or 'category'
	isCategory: false,
	currentCategory: false,
	pageContainers: {
		search: "#search-page",
		category: "#o-product-listing"
	},
	views: {
		products: {
			id: "products-tab",
			contentId: "products-tab-content",
			itemsPerPage: 30,
			maxItems: false,
			singularLabel: "tuote",
			pluralLabel: "tuotetta",
			sortOrder: "",
			// Note: Settings can override this. Also "default" sort option will always mean Loop54 sorting.
			sortOptions: [
				"popularity-desc",
				"newUntil-desc",
				"brand-asc",
				"brand-desc",
				"currentPrice-asc",
				"currentPrice-desc",
				"ovhComparisonPercent-desc"
			],
			// This is also facet order.
			possibleFacets: [
				"targetGroups",
				"sizes",
				"brand",
				"mainColour",
				"sustainability",
				"productType",
				"category",
				"subcategory",
				"sports",
				// 'technologies',
				"shopAvailability"
			],
			filterbarFacets: [
				"targetGroups",
				"sizes",
				"brand",
				"mainColour",
				"sustainability",
				"productType",
				"category",
				"subcategory",
				"sports",
				// 'technologies',
				"shopAvailability"
			],
			scopedTerms: true,
			// Append product name
			productAdditons: {},
			lookups: {}
		},
		articles: {
			id: "articles-tab",
			contentId: "articles-tab-content",
			itemsPerPage: 18,
			singularLabel: "artikkeli",
			pluralLabel: "artikkelia",
			possibleFacets: [],
			filterbarFacets: [],
			scopedTerms: false
		},
		shops: {
			id: "shops-tab",
			contentId: "shops-tab-content",
			itemsPerPage: 18,
			singularLabel: "kauppa",
			pluralLabel: "kauppaa",
			possibleFacets: [],
			filterbarFacets: [],
			scopedTerms: false
		}
	},
	facetNameMapping: {
		targetGroups: "Kohderyhmä",
		category: "Kategoria",
		subcategory: "Alakategoria",
		brand: "Brändi",
		sports: "Laji",
		productType: "Tuotetyyppi",
		mainColour: "Väri",
		sizes: "Koko",
		sustainability: "Vastuullisuus",
		shopAvailability: "Kauppasaatavuus",
		technologies: "Teknologiat"
	},
	targetGroupsOrder: {
		"Aikuiset": 0,
		"Naiset": 1,
		"Miehet": 2,
		"Nuoret": 3,
		"Tytöt": 4,
		"Pojat": 5,
		"Lapset": 6
	},
	showMaxSuggestions: 9, // suggestions and scoped suggestions combined.
	showMaxScopedSuggestions: 3, // Max scoped suggestions
	loop54Options: {
		search: {
			resultsOptions: {
				skip: 0,
				take: 30
			},
			relatedResultsOptions: {
				skip: 0,
				take: 10
			},
			spellingSuggestionsOptions: {
				skip: 0,
				take: 6
			},
			relatedQueriesOptions: {
				skip: 0,
				take: 6
			},
			customData: {
				pageResultsOptions: {
					skip: 0,
					take: 18
				},
				shopResultsOptions: {
					skip: 0,
					take: 18
				}
			}
		},
		category: {
			resultsOptions: {
				skip: 0,
				take: 30
			}
			/*	filter: {
					and: [
						{ attributeName: 'category' },
						{ type: 'attribute', attributeName: 'targetGroups', value: 'Miehet' }
					]
				} */
		},
		// suggestions: { skip: 0, take: 10, customData: { directSearch: true } }
		suggestions: { skip: 0, take: 9 }
	}
};

if (typeof __searchFilters === "object" && __searchFilters) {
	Object.assign(Settings.loop54Options.search.resultsOptions,
		__searchFilters
	);
}

if (typeof __productListingSettings === "object" && __productListingSettings) {

	const addViewSettings = (view) => {
		for (const key of Object.keys(__productListingSettings[view])) {
			Settings.views[view][key] = __productListingSettings[view][key];
		}
		delete __productListingSettings[view];
	};

	if (__productListingSettings.products) {
		addViewSettings("products");
	}

	if (__productListingSettings.articles) {
		addViewSettings("articles");
	}

	if (__productListingSettings.shops) {
		addViewSettings("shops");
	}

	for (const key of Object.keys(__productListingSettings)) {
		Settings[key] = __productListingSettings[key];
	}
}



let State = {
	// General elements
	searchBoxes: false,
	searchButtons: false,
	page: false,
	searchContainer: false,
	noSearchText: false,

	searchBoxDesktop: false,
	searchBoxMobile: false,
	relatedQueries: false,
	spellingSuggestions: false,
	searchText: false,
	searchTextScoped: false,
	makesSense: false,
	suggestions: false,

	// View specific stuff.
	views: {
		products: {
			type: "product",
			template: "",
			filterBlurListener: false,
			loop54FiltersHandler: false,
			hasMoreResults: false,
			elems: {
				elem: false,
				content: false,
				searchFacets: false,
				results: false,
				relatedSearchResultsContainer: false,
				relatedResults: false,
				showMoreResults: false,
				orderBy: false
			},
			params: {
				currentIndex: 0,
				currentItemsCount: 0,
				allItemsCount: 0,
				orderBy: false,
				userFacets: [],
				selectedFacets: {}
			},
			fetchedFacets: false
		},
		articles: {
			type: "article",
			template: "",
			filterBlurListener: false,
			loop54FiltersHandler: false,
			hasMoreResults: false,
			elems: {
				elem: false,
				content: false,
				searchFacets: false,
				results: false,
				relatedSearchResultsContainer: false,
				relatedResults: false,
				showMoreResults: false,
				orderBy: false
			},
			params: {
				currentIndex: 0,
				currentItemsCount: 0,
				allItemsCount: 0,
				orderBy: false,
				userFacets: [],
				selectedFacets: {}
			}
		},
		shops: {
			type: "shop",
			template: "",
			filterBlurListener: false,
			loop54FiltersHandler: false,
			hasMoreResults: false,
			elems: {
				elem: false,
				content: false,
				searchFacets: false,
				results: false,
				relatedSearchResultsContainer: false,
				relatedResults: false,
				showMoreResults: false,
				orderBy: false
			},
			params: {
				currentIndex: 0,
				currentItemsCount: 0,
				allItemsCount: 0,
				orderBy: false,
				userFacets: [],
				selectedFacets: {}
			}
		}
	},
	activeView: "products", // Initial view
	client: new Loop54Connector(),
	searchController: false,
	suggestionsController: false,
	hasSuggestionListener: false,
	params: {
		// allFacets: [],
		suggestionsQuery: "",
		searchTerm: "",
		scopedTerm: false,
		scope: false,
		page: false
	},
	restoreState: false,
	hadPageParam: false,
	firstLoad: true,
	cache: {}
};

let Loop54SearchProxy = {};

class Loop54Search {

	constructor(settings, state) {

		if (settings) {
			this.settings = settings;
		}

		if (state) {
			this.state = state;
		}

		Loop54SearchProxy = this;

	}

	set settings(settings) {
		Settings = settings;
	}

	/* get loop54FiltersHandler() {
		return loop54FiltersHandler;
	}*/

	get settings() {
		return Settings;
	}

	set state(state) {
		State = state;
	}

	get state() {
		return State;
	}

	getElements(containerOnly) {

		if (containerOnly) {
			return document.querySelector(Settings.pageContainers[Settings.loop54Mode]);
		} else {


			State.page = document.querySelector(Settings.pageContainers[Settings.loop54Mode]);

			if (State.page && !State.page.querySelector(".search-container")) {
				if (Templates.page) {
					const searchParam = new URLSearchParams(window.location.search);
					if (searchParam.has(Settings.searchQueryParam) && searchParam.get(Settings.searchQueryParam).trim()) {
						State.page.innerHTML = Mustache.render(Templates.page, { searchTerm: searchParam.get(Settings.searchQueryParam).trim() });
					} else if (sessionStorage.getItem(Settings.searchParamKey)) {
						State.page.innerHTML = Mustache.render(Templates.page, { searchTerm: sessionStorage.getItem(Settings.searchParamKey) });
					} else {
						State.page.innerHTML = Mustache.render(Templates.page, { noQuery: true });
					}
				}

			}


			State.searchContainer = document.querySelector(".search-container");
			State.searchBoxes = document.querySelectorAll(".search-box");
			State.searchBoxDesktop = document.querySelector(".search-box.desktop");

			if (State.searchBoxDesktop && State.searchBoxDesktop.dataset.endpoint) {
				Settings.endpoint = State.searchBoxDesktop.dataset.endpoint;
			}

			State.searchBoxMobile = document.querySelector(".search-box.mobile");
			State.searchButtons = document.querySelectorAll(".search-button");
			State.noSearchText = document.querySelector("#no-search-text");
			State.searchTextScoped = document.querySelectorAll(".search-term-scoped");
			State.relatedQueries = document.getElementById("related-queries");
			State.spellingSuggestions = document.getElementById("spelling-suggestions");
			State.searchText = document.querySelectorAll(".search-term");
			State.makesSense = document.querySelector(".makes-sense");
			State.suggestions = document.querySelectorAll(".search-suggestions");
			State.productTemplate = Templates.productTemplate;
			State.resultItemTemplate = Templates.resultItemTemplate;

			// Loop through views to set view specific elements
			for (let view of Object.keys(State.views)) {

				if (Settings.isCategory) {
					State.views[view].elems.content = document.querySelector(Settings.pageContainers.category);
				} else {
					State.views[view].elems.elem = document.getElementById(Settings.views[view].id);
					State.views[view].elems.content = document.getElementById(Settings.views[view].contentId);
				}

				if ((State.views[view].elems.elem || Settings.isCategory) && State.views[view].elems.content) {
					State.views[view].elems.searchFacets = State.views[view].elems.content.querySelector(".search-facets");
					State.views[view].elems.results = State.views[view].elems.content.querySelector(".js-search-results");
					State.views[view].elems.relatedSearchResultsContainer = State.views[view].elems.content.querySelector(".related-search-results-container");
					State.views[view].elems.relatedResults = State.views[view].elems.content.querySelector(".js-related-search-results");
					State.views[view].elems.showMoreResults = State.views[view].elems.content.querySelector(".load-more-results");
					State.views[view].elems.orderBy = State.views[view].elems.content.querySelector(".facet-order-by");

					if (Settings.views[view].possibleFacets && Settings.views[view].possibleFacets.length) {
						State.views[view].loop54FiltersHandler = new Loop54FiltersHandler(view, Settings, State);
						State.views[view].params.userFacets = State.views[view].loop54FiltersHandler.getCurrentFacets();
					}
				}
			}

			if (State.productTemplate) {
				Mustache.parse(State.productTemplate);
			}
			if (State.resultItemTemplate) {
				Mustache.parse(State.resultItemTemplate);
			}
		}

	}

	renderRealtedQueries(data) {

		if (!data) {
			return false;
		}
		const relatedQueries = data.relatedQueries;
		const spellingSuggestions = data.spellingSuggestions;
		if (!relatedQueries || (Array.isArray(relatedQueries.items) && relatedQueries.items.length === 0)) {
			this.clearRelatedQueries();
		}

		if (!spellingSuggestions || (Array.isArray(spellingSuggestions.items) && spellingSuggestions.items.length === 0)) {
			this.clearSpellingSuggestion();
		}

		if (relatedQueries && relatedQueries.items && relatedQueries.items.length > 0 || relatedQueries && relatedQueries.scoped && relatedQueries.scoped.length > 0) {
			if (State.relatedQueries) {
				const lastItem = relatedQueries.items[relatedQueries.items.length - 1];
				lastItem.last = true;
				State.relatedQueries.innerHTML = Mustache.render(Templates.relatedQueries, { ...relatedQueries, infoText: "Muut hakivat" });
				State.relatedQueries.classList.add("visible");
			}
		} else {
			this.clearRelatedQueries();
		}

		if (spellingSuggestions && spellingSuggestions.items && spellingSuggestions.items.length > 0 || spellingSuggestions && spellingSuggestions.scoped && spellingSuggestions.scoped.length > 0) {
			if (State.spellingSuggestions) {
				const lastItem = spellingSuggestions.items[spellingSuggestions.items.length - 1];
				lastItem.last = true;
				State.spellingSuggestions.innerHTML = Mustache.render(Templates.relatedQueries, { ...spellingSuggestions, infoText: "Tarkoititko" });
				State.spellingSuggestions.classList.add("visible");
			}
		} else {
			this.clearSpellingSuggestion();
		}
	}

	/**
	 * Update pagination links in head (for search engines): rel="prev" and rel="next" and load more button.
	 *
	 * @param {*} view - State view object.
	 * @returns {void} Returns void if not category.
	 */
	updatePaginationLinks(view = State.activeView) {

		if (!Settings.isCategory) {
			return;
		}

		// updatePaginationLinks will update the next page link if it exists.
		const showMoreButton = State.views[view].elems.showMoreResults?.querySelector(".js-load-more-results");
		// This will dynamically add href if load more button is a link.
		if (showMoreButton && (showMoreButton.tagName === "A")) {
			if (!State.views[view].hasMoreResults) {
				showMoreButton.removeAttribute("href");
			}
		}

		const currentPageIndex = State.views[view].params.currentIndex / Settings.views[view].itemsPerPage;
		const prevPageIndex = currentPageIndex - 1;
		const prevLink = document.querySelector('link[rel="prev"]');
		const nextLink = document.querySelector('link[rel="next"]');

		const relUrl = new URLSearchParams();

		const urlParams = new URLSearchParams(window.location.search);

		if (urlParams.has(Settings.idParam)) {
			relUrl.set(Settings.idParam, urlParams.get(Settings.idParam));
		}

		if (urlParams.has(Settings.orderParam)) {
			relUrl.set(Settings.orderParam, urlParams.get(Settings.orderParam));
		}

		if (urlParams.has(Settings.facetsParam)) {
			relUrl.set(Settings.facetsParam, urlParams.get(Settings.facetsParam));
		}

		let params = relUrl.toString();
		let currentUrl = `${window.location.origin}${window.location.pathname}${params ? `?${params}` : ""}`;

		let prevUrl = currentUrl;

		// Don't add page param if previous would be 1, just use the root url (i.e. default above).
		if (currentPageIndex > 2) {
			relUrl.set(Settings.pageParam, currentPageIndex - 1);
			const prevLinkParams = relUrl.toString();
			prevUrl = `${window.location.origin}${window.location.pathname}${prevLinkParams ? `?${prevLinkParams}` : ""}`;
		}

		relUrl.set(Settings.pageParam, currentPageIndex + 1);
		params = relUrl.toString();
		currentUrl = `${window.location.origin}${window.location.pathname}${params ? `?${params}` : ""}`;
		const nextUrl = currentUrl;

		const hasMoreResults = State.views[view].hasMoreResults;

		if (prevLink) {
			if (prevPageIndex >= 1) {
				prevLink.setAttribute("rel", "prev");
				prevLink.setAttribute("href", prevUrl);
			} else {
				prevLink.remove();
			}

		} else if (currentPageIndex > 1) {
			const prevLink = document.createElement("link");
			prevLink.setAttribute("rel", "prev");
			prevLink.setAttribute("href", prevUrl);
			document.head.appendChild(prevLink);
		}

		if (hasMoreResults) {
			if (nextLink) {
				nextLink.setAttribute("rel", "next");
				nextLink.setAttribute("href", nextUrl);
			} else {
				const nextLink = document.createElement("link");
				nextLink.setAttribute("rel", "next");
				nextLink.setAttribute("href", nextUrl);
				document.head.appendChild(nextLink);
			}

			// This will dynamically add href if load more button is a link.
			if (showMoreButton && (showMoreButton.tagName === "A")) {
				const urlActiveParams = new URLSearchParams(window.location.search);

				if (urlActiveParams.has(Settings.pageParam)) {
					urlActiveParams.set(Settings.pageParam, currentPageIndex);
					if (currentPageIndex === 1) {
						urlActiveParams.delete(Settings.pageParam);
					}
					const urlActiveParamsString = urlActiveParams.toString();
					history.replaceState(null, "", urlActiveParamsString ? "?" + urlActiveParamsString : window.location.pathname);
				}

				if (!State.views[view].hasMoreResults) {
					showMoreButton.removeAttribute("href");
				} else {

					if (nextUrl) {
						showMoreButton.setAttribute("href", nextUrl);
					}

				}
			}
		} else {
			if (nextLink) {
				nextLink.remove();
			}
		}
	}

	/*
	addPageParam(view = State.activeView) {
		const currentPageIndex = State.views[view].params.currentIndex / Settings.views[view].itemsPerPage;
		const urlParams = new URLSearchParams(window.location.search);

		if (!urlParams.has(Settings.pageParam) && currentPageIndex > 1) {
			urlParams.set(Settings.pageParam, currentPageIndex);
			history.replaceState({}, '', '?' + encodeURI(urlParams.toString()));
		}
	} */



	updateCounts(view) {

		if (State.views[view].elems.content) {
			for (const elem of State.views[view].elems.content.querySelectorAll(".current-search-items-count")) {
				elem.textContent = State.views[view].params.currentItemsCount;
			}

			for (const elem of State.views[view].elems.content.querySelectorAll(".all-search-item-count")) {
				elem.textContent = State.views[view].params.allItemsCount;
			}

			if (!Settings.isCategory) {
				const elemTotalCount = State.views[view].elems.elem.querySelector(".js-total-count");
				if (elemTotalCount) {
					elemTotalCount.textContent = State.views[view].params.allItemsCount;
				}
			}

			if (State.views[view].params.allItemsCount === 0) {
				if (!Settings.isCategory) {
					State.views[view].elems.elem.disabled = true;
				}
				State.views[view].elems.content.classList.add("no-results");
			} else {
				if (!Settings.isCategory) {
					State.views[view].elems.elem.disabled = false;
				}
				State.views[view].elems.content.classList.remove("no-results");
			}

			for (const elem of State.views[view].elems.content.querySelectorAll(".search-item-count-text")) {
				if (State.views[view].params.allItemsCount === 1) {
					elem.textContent = ` ${Settings.views[view].singularLabel}`;
				} else {
					elem.textContent = ` ${Settings.views[view].pluralLabel}`;
				}
			}
		}
	}

	getViewResultsObj(view, data) {
		let viewData = null;

		if (view === "products" && data.results) {
			viewData = {
				results: data.results,
				relatedResults: data.relatedResults
			};
		} else if (view === "articles" && data.customData && data.customData.pageResults) {
			viewData = {
				results: data.customData.pageResults.results,
				relatedResults: null
			};
		} else if (view === "shops" && data.customData && data.customData.shopResults) {
			viewData = {
				results: data.customData.shopResults.results,
				relatedResults: null
			};
		}

		return viewData;
	}

	updateViewState(view, data, newSearch, restoredState) {
		let viewData = this.getViewResultsObj(view, data);
		if (!viewData) {
			viewData = {
				results: {
					count: 0,
					items: []
				}
			};
		}

		if (restoredState) {
			State.views[view].params.currentItemsCount = viewData.results.items.length;
		} else {
			State.views[view].params.currentItemsCount = Math.min(State.views[view].params.currentIndex + viewData.results.items.length, viewData.results.count);
			State.views[view].params.currentIndex += Settings.views[view].itemsPerPage;
		}

		const maxItems = Settings.isCategory ? (Settings.views[view].maxItems || false) : false;

		State.views[view].params.allItemsCount = maxItems ? Math.min(viewData.results.count, maxItems) : viewData.results.count;


		this.updateCounts(view);

		if (State.views[view].elems.showMoreResults) {
			if (State.views[view].params.currentIndex >= State.views[view].params.allItemsCount || viewData.results.items.length === 0 || Settings.views[view].itemsPerPage > viewData.results.items.length) {
				State.views[view].hasMoreResults = false;
				State.views[view].elems.showMoreResults.classList.remove("has-more-results");
			} else {
				State.views[view].hasMoreResults = true;
				State.views[view].elems.showMoreResults.classList.add("has-more-results");
			}
		}

		this.updatePaginationLinks(view);
		// adding page param to url is currently disabled beacause of bad user experience when refreshing page: only that pages's results are shown.
		// this can be enabled if we create the "Load more results on scroll" feature.
		// this.addPageParam(view);

		if (newSearch) {
			if (viewData.relatedResults && State.views[view].elems.relatedSearchResultsContainer) {
				if (viewData.relatedResults.count > 0) {
					State.views[view].elems.relatedSearchResultsContainer.classList.add("has-results");
				} else {
					State.views[view].elems.relatedSearchResultsContainer.classList.remove("has-results");
				}
			}
		}

		return State.views[view].params.allItemsCount > 0 ? true : false;
	}

	parseResultItems(items, type) {
		let resultItems = [];
		let removed = false;
		try {
			const getItemJson = (itemsJson, item) => {
				let resItem = "";

				const renderDataObject = item.attributes.find(attribute => attribute.name === "renderDataObject");
				if (renderDataObject && renderDataObject.values) {
					resItem = renderDataObject.values[0] || "";
				}

				if (resItem && item.type === type) {
					itemsJson.push(resItem);
				}

				if (item.type !== type) {
					removed = true;
				}

				return itemsJson;
			};

			resultItems = JSON.parse("[" + items.reduce(getItemJson, []).join(",") + "]");
		} catch (e) {
			// whoops
		}

		if (removed) {
			console.log("|||||| ______ ^^^^^^^ ********* Unexpected result types ********* ^^^^^^^ ______ ||||||");
		}

		return resultItems;
	}

	appendSearchWordUrlParam(baseUrl) {

		const url = new URL(baseUrl, window.location.origin);
		// Not needed for Budget Sport
		// url.searchParams.set("searchWords", State.params.searchTerm);

		return url.pathname + url.search;
	}

	updateProducts(data) {
		const searchProducts = this.parseResultItems(data.results.items, "Product");

		const relatedProducts = Settings.isCategory ? [] : this.parseResultItems(data.relatedResults.items, "Product");
		const addedProducts = [];

		const {
			addProductType = false,
			addTargetGroup = false,
			customProductType = ""
		} = (Settings.isCategory ? Settings.views.products : {});

		const renderProduct = (product, mainElement) => {
			if (mainElement) {
				if (!Settings.isCategory) {
					product.url = this.appendSearchWordUrlParam(product.url);
				}

				const productItem = document.createElement("div");
				productItem.innerHTML = Mustache.render(State.productTemplate, product);
				const productElement = productItem.firstChild;
				productElement.dataset.type = "Product";
				addedProducts.push(productElement);
				mainElement.appendChild(productElement);
			}
		};

		if (Settings.isCategory) {
			const noIndexMetadata = document.head.querySelector("meta[data-no-products=true]");
			if (noIndexMetadata) {
				noIndexMetadata.remove();
			}
		}

		if (searchProducts.length === 0 && State.views.products.elems.results) {
			if (Settings.isCategory) {
				State.views.products.elems.results.innerHTML = Templates.noProducts;
			} else {
				State.views.products.elems.results.innerHTML = Templates.noSearchResults;
			}

			if (Settings.isCategory && State.hadPageParam) {
				// https://developers.google.com/search/docs/advanced/javascript/javascript-seo-basics#avoid-soft-404s
				// Another alternative would be to do a 404 redirect.
				const metaRobots = document.createElement("meta");
				metaRobots.name = "robots";
				metaRobots.content = "noindex";
				metaRobots.dataset.noProducts = true;
				document.head.appendChild(metaRobots);
				State.hadPageParam = false;
			}
		}

		for (const product of searchProducts) {

			let productNameAdditions = [];
			if (addTargetGroup) {
				productNameAdditions.push(addTargetGroup);
			}

			if (addProductType) {
				const productTypeText = customProductType ? customProductType : product.titleCategory;
				if (!String(product.productname).toLowerCase().includes(String(productTypeText).toLowerCase())) {
					productNameAdditions.push(customProductType ? customProductType : product.titleCategory);
				} else {
					productNameAdditions = [];
				}
			}

			if (productNameAdditions.length > 0) {
				product.productname = (product.rawProductName || product.productname) + " - " + productNameAdditions.join(" ");
			}

			renderProduct(product, State.views.products.elems.results);
		}

		if (!Settings.isCategory) {
			for (const product of relatedProducts) {
				renderProduct(product, State.views.products.elems.relatedResults);
			}
		}

		return addedProducts;
	}

	createResultItem(data, mainElement) {
		const resultItem = document.createElement("div");
		resultItem.innerHTML = Mustache.render(State.resultItemTemplate, data);
		const resultElement = resultItem.firstChild;
		resultElement.dataset.type = "Article";
		mainElement.appendChild(resultElement);
	}

	updateArticles(data) {
		if (State.views.articles.elems.results && data.customData && data.customData.pageResults && data.customData.pageResults.results && data.customData.pageResults.results.items.length) {
			const items = this.parseResultItems(data.customData.pageResults.results.items, "pageEntity");

			for (const item of items) {
				const resultItemData = {
					fullLinkParent: true,
					sideCol: !!item.image,
					sideCentered: false,
					mobileFullWidth: false,
					category: item.contentType,
					heading: item.title,
					link: item.link,
					type: item.type,
					image: item.image ? item.image.href : null
				};

				this.createResultItem(resultItemData, State.views.articles.elems.results);
			}

			if (items.length === 0 && State.views.products.elems.results) {
				State.views.articles.elems.results.innerHTML = Templates.noSearchResults;
			}
		}

	}

	updateShops(data) {
		if (State.views.shops.elems.results && data.customData && data.customData.shopResults && data.customData.shopResults.results && data.customData.shopResults.results.items.length) {
			const items = this.parseResultItems(data.customData.shopResults.results.items, "shopEntity");

			for (const item of items) {
				const resultItemData = {
					sideCol: !!item.mapUrl,
					sideCentered: true,
					mobileFullWidth: true,
					fullLinkParent: !item.mapUrl,
					category: "Budget Sport",
					heading: item.name,
					link: item.link,
					type: null,
					image: null,
					shop: {
						shopAddress: item.address ? `${item.address}, ${item.postNumber} ${item.city}` : null,
						shopOpeningHours: item.shopOpenStatus ? `${item.shopOpenStatus}${item.shopOpens ? " " + item.shopOpens : ""}${item.shopCloses ? "-" + item.shopCloses : ""}` : null
					},
					cta: item.mapUrl ? {
						ctaLink: item.mapUrl,
						ctaLabel: "Ajo-ohjeet"
					} : null
				};

				this.createResultItem(resultItemData, State.views.shops.elems.results);
			}

			if (items.length === 0 && State.views.products.elems.results) {
				State.views.articles.elems.shopResults.innerHTML = Templates.noSearchResults;
			}
		}
	}

	updateResults(view, data) {
		if (view === "products") {
			return this.updateProducts(data);
		} else if (view === "articles") {
			return this.updateArticles(data);
		} else if (view === "shops") {
			return this.updateShops(data);
		}
		return false;
	}

	handleSearchResults(params = {}) {

		const { data, newSearch, restoredState, clear } = params;

		if (!data) {
			return false;
		}

		// Shared elements
		if (newSearch) {
			this.clearRelatedQueries();
			this.clearSpellingSuggestion();
			this.renderRealtedQueries(data);
		}

		// Remove no query element
		if (State.searchContainer && State.searchContainer.classList.contains("no-query")) {
			State.searchContainer.classList.remove("no-query");

			if (State.noSearchText) {
				State.noSearchText.parentElement.removeChild(State.noSearchText);
			}
		}

		// Each view
		let viewsWithResults = [];
		for (let view of Object.keys(State.views)) {
			if (!newSearch && view !== State.activeView) {
				if (State.views[view].elems.results.children.length) {
					viewsWithResults.push(view);
				}

				// This view doesn't need an update
				continue;
			}

			if (newSearch || clear) {
				if (State.views[view].loop54FiltersHandler) {
					State.views[view].loop54FiltersHandler.handleFacets(data, newSearch);
				}
			}

			if (restoredState) {
				if (State.views[view].elems.searchFacets) {
					State.views[view].elems.searchFacets.dataset.skipFacetUpdate = false;
				}
			}

			const viewHasResults = this.updateViewState(view, data, newSearch, restoredState);
			if (viewHasResults) {
				viewsWithResults.push(view);
			}

			const addedItems = this.updateResults(view, data);

			if (Settings.isCategory) {
				if (clear) {
					loop54promos.addPromotionItemsToList();
				} else {
					loop54promos.addPromotionItems(addedItems);
				}
			}
		}

		if (viewsWithResults.length) {
			State.searchContainer.classList.remove("no-results");

			// Check if active view has no results
			if (State.views[State.activeView].params.allItemsCount === 0) {
				State.views[viewsWithResults[0]].elems.elem.click();
			}
		} else {
			State.searchContainer.classList.add("no-results");
		}

		if (State.makesSense) {
			if (!viewsWithResults.length && !data.makesSense) {
				State.makesSense.textContent = Settings.searchMakesNoSenseText + ' "' + State.params.searchTerm + '".';
				State.makesSense.style.display = "block";
			} else {
				State.makesSense.textContent = "";
				State.makesSense.style.display = "";
			}
		}
	}

	updateViewSearchOpts(view, optsObj) {
		optsObj.skip = State.views[view].params.currentIndex;
		optsObj.take = Settings.views[view].itemsPerPage;


		if (Settings.isCategory) {
			// Ensure that we don't load more than max items.

			const maxItems = Settings.views.products.maxItems || false;

			if ((maxItems > 0)) {
				if (maxItems < optsObj.take) {
					optsObj.take = maxItems;
				} else {

					if (optsObj.skip + optsObj.take > maxItems) {
						optsObj.take = maxItems - optsObj.skip;
					}

				}
				if (optsObj.skip > maxItems) {
					optsObj.take = 0;
				}
			}
		}


		if (Settings.isCategory && Settings.views[view]?.resultsOptions?.filter) {
			optsObj.filter = Settings.views[view].resultsOptions.filter;
		}

		if (Settings.views[view].possibleFacets.length) {
			optsObj.facets = State.views[view].params.userFacets;
		}



		// Inject pre-selected facets here.
		if (Settings.isCategory && State.firstLoad && !(State.restoreState && State.restoreState.views[view])) {


			const urlFacets = State.views[view].loop54FiltersHandler.getUrlFacets();

			const possibleFacets = Settings.views[view]?.possibleFacets || [];

			// Filter out facets that are not allowed.
			const userFacets = Object.entries({ ...(Settings.views[view]?.userFacets || {}), ...urlFacets }).reduce((acc, [key, value]) => {

				if (possibleFacets.includes(key)) {
					acc[key] = value;
				}
				return acc;
			}, {});

			if (userFacets && Object.keys(userFacets).length) {

				State.views[view].loop54FiltersHandler.writeFacets(userFacets, true);

				optsObj.facets = State.views[view].loop54FiltersHandler.getCurrentFacets();
			}

			// This would allow automatic selection of target group. However,
			// in order to work properly this would need additional checks (do not apply women in mens category for example)
			// and should be merger with userFacets if those are provided.
			// const navTargetGroups = this.getPrefferredTargetGroup();

			// if (navTargetGroups) {
			// 	State.views[view].loop54FiltersHandler.writeFacets({
			// 		targetGroups: navTargetGroups
			// 	}, true);

			// 	optsObj.facets = State.views.products.loop54FiltersHandler.getCurrentFacets();
			// }


		}

		if (State.views[view].loop54FiltersHandler) {
			State.views[view].loop54FiltersHandler.updateOrderBy();
		}

		if (State.views[view].params.orderBy) {
			optsObj.sortBy = State.views[view].params.orderBy;
		}
	}

	getViewSearchOpts(view, searchOptions) {
		let optsObj = null;

		// Load more results for current view
		if (view === "products") {

			if (!searchOptions.resultsOptions) {
				searchOptions.resultsOptions = {};
			}
			optsObj = searchOptions.resultsOptions;
		} else if (view === "articles") {
			if (!searchOptions.customData) {
				searchOptions.customData = {};
			}
			if (!searchOptions.customData.pageResultsOptions) {
				searchOptions.customData.pageResultsOptions = {};
			}
			optsObj = searchOptions.customData.pageResultsOptions;

			// If scoped term is used, but this view does not support them
			if (State.params.scopedTerm && State.params.scope && !Settings.views[view].scopedTerms) {
				optsObj = null;
				delete searchOptions.customData.pageResultsOptions;
			}
		} else if (view === "shops") {
			if (!searchOptions.customData) {
				searchOptions.customData = {};
			}
			if (!searchOptions.customData.shopResultsOptions) {
				searchOptions.customData.shopResultsOptions = {};
			}
			optsObj = searchOptions.customData.shopResultsOptions;

			// If scoped term is used, but this view does not support them
			if (State.params.scopedTerm && State.params.scope && !Settings.views[view].scopedTerms) {
				optsObj = null;
				delete searchOptions.customData.shopResultsOptions;
			}
		}

		if (optsObj) {
			this.updateViewSearchOpts(view, optsObj);
		}

		return optsObj;
	}

	getPrefferredTargetGroup() {
		let storageType = localStorage;
		if (!storageType) {
			storageType = sessionStorage;
		}

		const mappings = {
			men: ["Miehet"],
			women: ["Naiset"],
			children: ["Tytöt", "Pojat", "Lapset"]
		};

		if (storageType && storageType.getItem("navigationState")) {
			try {
				const navigationData = JSON.parse(storageType.getItem("navigationState"));
				return mappings[navigationData.navigation] || false;
			} catch (error) {
				return false;
			}
		} else {
			return false;
		}
	}

	handleSearch(searchParams = {}) {

		const { clear, clearScope, keepFilters, newSearch, redirectToSearch } = { clear: true, clearScope: true, keepFilters: false, newSearch: true, ...searchParams };

		if (searchParams.activeView && searchParams.activeView !== State.activeView) {
			State.activeView = searchParams.activeView;
		}

		if (State.suggestionsController) {
			State.suggestionsController.abort();
		}

		this.resetStoredState();

		// This is intended for search engines only. When using page param
		// only current page items are loaded. Also not intended for search.
		let hasPageParam = false;
		let urlParams = false;
		if (Settings.isCategory) {
			urlParams = new URLSearchParams(window.location.search);
			hasPageParam = urlParams.has(Settings.pageParam);
			State.hadPageParam = hasPageParam;
		} else {
			State.params.page = false;
		}

		if (clear) {
			if (hasPageParam && !State.firstLoad) {
				urlParams.delete(Settings.pageParam);
				const urlParamsString = urlParams.toString();
				history.replaceState(null, "", urlParamsString ? "?" + urlParamsString : window.location.pathname);
			}
			const value = String(State.searchBoxDesktop.value).trim();
			State.params.searchTerm = value;
		} else {
			if (hasPageParam) {
				const previousPage = parseInt(urlParams.get(Settings.pageParam));
				if (previousPage > 0) {
					urlParams.set(Settings.pageParam, previousPage + 1);
					const urlParamsString = urlParams.toString();
					history.replaceState(null, "", "?" + urlParamsString);
				}
			}
		}

		// Update views
		if (newSearch) {
			for (let view of Object.keys(State.views)) {
				if (State.views[view].loop54FiltersHandler) {
					State.views[view].loop54FiltersHandler.resetFacets();
				}
			}
		}

		if (clear && clearScope) {
			State.params.scopedTerm = false;
		}

		if (!Settings.isCategory || redirectToSearch) {

			// Not on search page. Search will be directed to search page.
			// We'll use session storage for search parameter so that search page
			// will load quickly from cache.
			if (!State.page || redirectToSearch) {
				if (State.params.scopedTerm && State.params.scope) {
					sessionStorage.setItem(Settings.searchScopeTermKey, State.params.scopedTerm);
					sessionStorage.setItem(Settings.searchScopeKey, State.params.scope);
				}
				sessionStorage.setItem(Settings.searchParamKey, State.params.searchTerm);
				window.location.href = Settings.endpoint;
				return true;
			} else {
				sessionStorage.removeItem(Settings.searchScopeTermKey);
				sessionStorage.removeItem(Settings.searchScopeKey);
				sessionStorage.removeItem(Settings.searchParamKey);
			}
		}

		if (State.searchController) {
			State.restoreState = false;
			State.searchController.abort();
		}

		if (!Settings.isCategory) {
			if (!State.params.searchTerm) {
				return false;
			}

			for (const searchText of State.searchText) {
				searchText.textContent = State.params.searchTerm;
			}

			if (State.params.scopedTerm) {
				document.title = `Hakutulokset: "${State.params.searchTerm}" kategoriassa ${State.params.scopedTerm} ${Settings.titleSuffix}`;
			} else {
				document.title = `Hakutulokset: "${State.params.searchTerm}" ${Settings.titleSuffix}`;
			}

			for (const searchTextScoped of State.searchTextScoped) {
				// if (Workset.params.scopedTerm && String(Workset.params.scopedTerm).trim().toLowerCase() !== String(Workset.params.searchTerm).toLowerCase()) {
				if (State.params.scopedTerm) {
					searchTextScoped.textContent = ` kategoriassa ${State.params.scopedTerm}`;
				} else {
					searchTextScoped.textContent = "";
				}
			}


			const urlParams = new URLSearchParams(window.location.search);
			urlParams.set(Settings.searchQueryParam, State.params.searchTerm);

			if (State.params.scopedTerm && State.params.scope) {
				urlParams.set(Settings.scopedQueryParam, State.params.scopedTerm);
				urlParams.set(Settings.scopeParam, State.params.scope);
			}

			if (clear && clearScope) {
				urlParams.delete(Settings.scopedQueryParam);
				urlParams.delete(Settings.scopeParam);
			}

			history.replaceState(null, "", "?" + urlParams);



			if (clear) {
				this.clearSuggestions();
				// this.clearRelatedQueries();
				// this.clearSpellingSuggestion();
			}

		}

		const hadScope = State.params.scopedTerm && State.params.scope;

		for (let view of Object.keys(State.views)) {
			// Update only relevant views
			if (newSearch || (!newSearch && view === State.activeView)) {
				// Clear previous search
				if (clear) {
					// Reset current index
					State.views[view].params.currentIndex = 0;

					// Remove old results and related results
					if (newSearch) {
						while (State.views[view].elems.relatedResults && State.views[view].elems.relatedResults.firstChild) {
							State.views[view].elems.relatedResults.removeChild(State.views[view].elems.relatedResults.firstChild);
						}
					}

					while (State.views[view].elems.results && State.views[view].elems.results.firstChild) {
						State.views[view].elems.results.removeChild(State.views[view].elems.results.firstChild);
					}
				}
			}

			// Set scope if scoped terms are used for this view
			if (State.views[view].loop54FiltersHandler) {
				if (hadScope && Settings.views[view].scopedTerms) {
					State.views[view].params.selectedFacets[State.params.scope] = [State.params.scopedTerm];

					State.views[view].loop54FiltersHandler.getCurrentFacets();
					State.views[view].loop54FiltersHandler.writeFacets(State.views[view].params.selectedFacets, true);
				}

				if (!keepFilters && !hadScope) {
					State.views[view].loop54FiltersHandler.getCurrentFacets(true);
				}

				if (!keepFilters) {
					State.views[view].loop54FiltersHandler.filterDropdownListener(true);
				}
			}
		}


		// Get search query options
		let searchOptions = {};
		let restoredState = false;
		if (newSearch) {
			// Default search params
			if (Settings.isCategory) {
				searchOptions = { ...Settings.loop54Options.category };
			} else {
				searchOptions = { ...Settings.loop54Options.search };
			}

			// Update all view params
			for (let view of Object.keys(State.views)) {
				const optsObj = this.getViewSearchOpts(view, searchOptions);

				// Restore search state
				if (optsObj && State.restoreState && State.restoreState.views[view]) {
					restoredState = true;

					optsObj.skip = 0;
					optsObj.take = State.restoreState.views[view].currentIndex || Settings.views[view].itemsPerPage;

					State.views[view].params.currentIndex = State.restoreState.views[view].currentIndex || 0;

					if (State.restoreState.views[view].orderBy) {
						State.views[view].params.orderBy = State.restoreState.views[view].orderBy;
						optsObj.sortBy = State.restoreState.views[view].orderBy;
					}

					if (Settings.views[view].possibleFacets.length && State.views[view].loop54FiltersHandler) {
						if (State.restoreState.views[view].userFacets) {
							State.views[view].params.userFacets = State.restoreState.views[view].userFacets;
							optsObj.facets = State.restoreState.views[view].userFacets;
						}

						if (State.restoreState.views[view].selectedFacets) {
							State.views[view].loop54FiltersHandler.writeFacets(State.restoreState.views[view].selectedFacets, true);
							State.views[view].params.selectedFacets = State.restoreState.views[view].selectedFacets;
						}
					}
				}
			}

			if (State.params.page && State.params.page > 0) {
				State.views[State.activeView].params.currentIndex = (Math.max(State.params.page - 1, 1)) * Settings.views[State.activeView].itemsPerPage;
				searchOptions.resultsOptions.skip = State.views[State.activeView].params.currentIndex;
			}
			State.params.page = false;

		} else {
			// Update only current view
			this.getViewSearchOpts(State.activeView, searchOptions);
		}


		// Remove custom data if nothing is being fetched
		if (searchOptions.customData && Object.keys(searchOptions.customData).length === 0) {
			delete searchOptions.customData;
		}

		if (!clear && dataLayer && !Settings.isCategory) {
			const itemsPerPage = Settings.views[State.activeView].itemsPerPage;
			const skip = searchOptions?.resultsOptions?.skip ?? searchOptions?.customData?.pageResultsOptions?.skip ?? false;

			if (itemsPerPage && skip) {
				dataLayer.push({
					event: "GAEvent",
					eventCategory: "Loop54Search",
					eventAction: `Load result page (${State.activeView})`,
					eventLabel: `${(skip + itemsPerPage) / itemsPerPage}/${Math.ceil(State.views[State.activeView].params.allItemsCount / itemsPerPage)}`
				});
			}
		}

		if (State.views[State.activeView].elems.showMoreResults) {
			State.views[State.activeView].elems.showMoreResults.classList.add("loading");
		}

		if (Settings.isCategory) {

			const { attribute = false, customData = false } = Settings.views[State.activeView] || {};
			if (attribute) {
				searchOptions.attribute = attribute;
			}

			if (customData) {
				searchOptions.customData = customData;
			}

			State.searchController = State.client[attribute ? "getEntitiesByAttribute" : "getEntities"](searchOptions, (data) => {
				if (data && data.error !== true) {
					try {
						this.resultsAnalytics(data);
						this.handleSearchResults({ data, newSearch, restoredState, clear });

						if (State.restoreState && State.restoreState.scrollPosition) {
							window.scroll(State.restoreState.scrollPosition.x, State.restoreState.scrollPosition.y);
						}
					} catch (error) {
						console.log(error);
					}

					if (State.views[State.activeView].elems.showMoreResults) {
						State.views[State.activeView].elems.showMoreResults.classList.remove("loading");
					}
					State.searchContainer?.classList.remove("no-items");

				} else {
					State.searchContainer?.classList.add("no-items");
					console.log("No data.");
				}

				State.restoreState = false;
				State.suggestionsController = false;
			});

		} else {
			State.searchController = State.client.search(State.params.searchTerm, searchOptions, (data) => {
				if (data && data.error !== true) {
					try {
						this.resultsAnalytics(data);
						this.handleSearchResults({ data, newSearch, restoredState, clear });

						if (State.restoreState && State.restoreState.scrollPosition) {
							window.scroll(State.restoreState.scrollPosition.x, State.restoreState.scrollPosition.y);
						}
					} catch (error) {
						console.log(error);
					}

					if (State.views[State.activeView].elems.showMoreResults) {
						State.views[State.activeView].elems.showMoreResults.classList.remove("loading");
					}
					State.searchContainer?.classList.remove("no-items");
				} else {
					State.searchContainer?.classList.add("no-items");
					console.log("No search data.");
				}

				State.restoreState = false;
				State.suggestionsController = false;
			});
		}

		State.firstLoad = false;
	}

	/**
	 * Add analytics data based on response data.
	 *
	 * @param {Object} responseData - Response data from Loop54.
	 */
	resultsAnalytics(responseData) {

		if (responseData && Array.isArray(dataLayer)) {
			// A/B testing dimension for sorting. Yeah, dimension name doesn't make sense.
			if (responseData?.customData?.side && !State.cache.ab) {
				State.cache.ab = true;
				dataLayer.push({ "MobileCart2019": responseData?.customData?.side });
			}
		}
	}

	clearRelatedQueries() {
		if (State.relatedQueries) {
			State.relatedQueries.textContent = "";
			State.relatedQueries.classList.remove("visible");
		}
	}

	clearSpellingSuggestion() {
		if (State.spellingSuggestions) {
			State.spellingSuggestions.textContent = "";
			State.spellingSuggestions.classList.remove("visible");
		}
	}

	clearSuggestions() {
		if (State.suggestions) {
			for (const suggestion of State.suggestions) {
				suggestion.classList.remove("has-results");
				suggestion.classList.remove("visible");
				if (State.hasSuggestionListener) {
					document.body.removeEventListener("click", this.suggestionBoxListeners);
					State.hasSuggestionListener = false;
				}
			}
		}
	}

	suggestionBoxListeners(e) {
		const elem = e.target;
		if (!elem.closest(".search-box-wrapper, .search-suggestions")) {


			if (!(Array.from(State.searchBoxes).includes(document.activeElement)) && State.suggestions) {
				for (const suggestion of State.suggestions) {
					suggestion.classList.remove("visible");
				}
			}

		}
	}

	processSuggestions(data) {
		if (!data) {
			return false;
		}

		const suggestionsObject = {
			suggestions: data.queries ? data.queries.items : [],
			scoped: []
		};

		if (data.scopedQuery && data.scopedQuery.scopes) {
			for (const scope of data.scopedQuery.scopes.slice(0, Settings.showMaxScopedSuggestions)) {
				suggestionsObject.scoped.push({
					query: data.scopedQuery.query,
					scope: data.scopedQuery.scopeAttributeName,
					suggestedScope: scope,
					suggestion: data.scopedQuery.query,
					suggestedCategory: scope,
					isScoped: true
				});
			}
		}

		const elements = State.suggestions;

		if (!elements.length === 0) {
			return false;
		}


		if (suggestionsObject.suggestions.length === 0 && suggestionsObject.scoped.length === 0) {
			this.clearSuggestions();
			return true;
		}

		let suggestionsTemplate = Templates.suggestions;
		Mustache.parse(suggestionsTemplate);

		if (suggestionsObject.suggestions && suggestionsObject.suggestions.length > 0 || suggestionsObject.scoped && suggestionsObject.scoped.length > 0) {

			const removeSuggestionsCount = suggestionsObject.suggestions.length + suggestionsObject.scoped.length - Settings.showMaxSuggestions;
			const renderData = {
				query: State.params.suggestionsQuery,
				suggestions: suggestionsObject.suggestions,
				scoped: suggestionsObject.scoped,
				items: []
			};

			if (removeSuggestionsCount > 0) {
				renderData.suggestions = renderData.suggestions.slice(0, Math.max(renderData.suggestions.length - removeSuggestionsCount), 0);
			}

			renderData.items = renderData.suggestions.concat(renderData.scoped);

			if (renderData.items.length > 0) {
				const lastItem = renderData.items[renderData.items.length - 1];
				lastItem.last = true;
			}

			for (const element of elements) {
				element.innerHTML = Mustache.render(suggestionsTemplate, renderData);
				element.classList.add("has-results");
				element.classList.add("visible");
				element.style.maxHeight = `calc(100vh - ${element.getBoundingClientRect().top}px)`;
			}
			if (!State.hasSuggestionListener) {
				State.hasSuggestionListener = true;
				document.body.addEventListener("click", this.suggestionBoxListeners);
			}
		} else {
			this.clearSuggestions();
		}

	}

	handleSuggestions() {
		let value = State.searchBoxDesktop.value;
		if (State.suggestionsController !== false) {
			State.suggestionsController.abort();
		}

		if (value) {
			value = String(value).trim();
			if (value.length >= Settings.minSuggestionLetters) {
				State.params.suggestionsQuery = value,
				State.suggestionsController = State.client.autoComplete(value, Settings.loop54Options.suggestions, (data) => {
					if (data && data.error !== true) {
						try {
							Loop54SearchProxy.processSuggestions(data);
						} catch (error) {
							console.log(error);
							Loop54SearchProxy.clearSuggestions();
						}
					} else {
						console.log("No suggestions data.");
						Loop54SearchProxy.clearSuggestions();
					}
					State.suggestionsController = false;
				});
			}
		} else {
			Loop54SearchProxy.clearSuggestions();
		}

	}

	resetStoredState() {
		sessionStorage.removeItem(Settings.stateStoreKey);
	}

	saveSearchState() {

		const state = {
			activeView: State.activeView,
			views: {},
			params: State.params,

			scrollPosition: { x: window.scrollX, y: window.scrollY }
		};

		for (let view of Object.keys(State.views)) {
			state.views[view] = {
				currentIndex: State.views[view].params.currentIndex,
				userFacets: State.views[view].params.userFacets,
				selectedFacets: State.views[view].params.selectedFacets,
				orderBy: State.views[view].params.orderBy
			};
		}

		const urlParams = new URLSearchParams(window.location.search);

		if (urlParams.has(Settings.searchQueryParam)) {
			urlParams.delete(Settings.searchQueryParam);
		}

		if (urlParams.has(Settings.scopedQueryParam)) {
			urlParams.delete(Settings.scopedQueryParam);
		}

		if (urlParams.has(Settings.scopeParam)) {
			urlParams.delete(Settings.scopeParam);
		}


		if (Array.from(urlParams.keys()).length === 0) {
			history.replaceState(null, "", window.location.pathname);
		} else {
			history.replaceState(null, "", "?" + urlParams);
		}

		let states = sessionStorage.getItem(Settings.stateStoreKey);
		try {
			states = JSON.parse(states);
			if (!(typeof states === "object" && states)) {
				states = {};
			}
		} catch (error) {
			states = {};
		}

		states[window.location.pathname] = state;

		sessionStorage.setItem(Settings.stateStoreKey, JSON.stringify(states));
	}

	restoreState() {
		if (!State.page) {
			return false;
		}

		let states = sessionStorage.getItem(Settings.stateStoreKey);
		try {
			states = JSON.parse(states);
			if (!(typeof states === "object" && states)) {
				states = false;
			}
		} catch (error) {
			states = false;
		}

		const stateObject = states[window.location.pathname];

		if (states && stateObject) {

			if (!Settings.isCategory) {
				const urlParams = new URLSearchParams(window.location.search);

				urlParams.set(Settings.searchQueryParam, stateObject.params.searchTerm);

				if (stateObject.params.scopedTerm) {
					urlParams.set(Settings.scopedQueryParam, stateObject.params.scopedTerm);
				}

				if (stateObject.params.scope) {
					urlParams.set(Settings.scopeParam, stateObject.params.scope);
				}

				history.replaceState(null, "", "?" + urlParams);
			}

			const activeView = stateObject.activeView || State.activeView;
			State.restoreState = {
				scrollPosition: stateObject.scrollPosition ? stateObject.scrollPosition : false,
				activeView: activeView,
				views: stateObject.views || {},
				params: stateObject.params
			};

			return true;
		} else {
			return false;
		}
	}
}

export default Loop54Search;
